import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage/LoginPage";
import HomePage from "./pages/HomePage/HomePage";
import HistoryPage from "./pages/HistoryPage/HistoryPage";
import Profile from "./pages/ProfilePage/ProfilePage";
import QRScanner from "./pages/QRScanPage/QRScan";
import Overtime from "./components/OvertimeComponent/OvertimeComponent";
import Patrol from "./components/PatrolComponent/PatrolComponent";
import Event from "./pages/EventPage/EventPage";
import ChangePasswordFirstLoginPage from "./pages/ChangePasswordFirstLoginPage/ChangePasswordFirstLoginPage";
import CheckOut from "./pages/CheckoutPage/CheckOut";
import SelfieCheckinPage from "./pages/SelfieCheckinPage/SelfieCheckin";
import SelfieCheckOutPage from "./components/SelfieCheckOut/SelfieCheckOut";
import ShiftChoosePage from "./pages/ShiftChoose/ShiftChoose";
import Overtime2 from "./components/Overtime2Component/OvertimeComponent";
import OvertimeList from "./components/Overtime2Component/OvertimeListComponent";
import PatrolLocation from "./pages/PatrolBarcodePage/ChooseLocationPage";
import PatrolQrcode from "./components/PatrolBarcodeComponent/PatrolBarcodeComponent";
import PatrolPage from "./pages/PatrolBarcodePage/PatrolPage";
import MapComponent from "./components/MapComponent/MapComponent";
import LogBookList from "./components/LogComponent/LogBookList";
import LogVehicle from "./components/LogComponent/LogVehicle";
import LogProduct from "./components/LogComponent/LogProduct";
import Payroll from "./pages/Payroll/PayrollPage";
const App: React.FC = () => {
  return (
    <Router>
      <div className="">
        <Routes>
          <Route path="/:initial" element={<LoginPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/home/checkin/:id" element={<QRScanner />} />
          <Route path="/home/overtime-form" element={<Overtime />} />
          <Route path="/home/patrol-form" element={<Patrol />} />
          <Route path="/home/event/:id" element={<Event />} />
          <Route
            path="/home/change-first-password"
            element={<ChangePasswordFirstLoginPage />}
          />
          <Route path="/home/checkout" element={<CheckOut />}></Route>
          <Route
            path="/home/selfie-checkin"
            element={<SelfieCheckinPage />}
          ></Route>
          <Route
            path="/home/selfie-checkout"
            element={<SelfieCheckOutPage />}
          ></Route>
          <Route
            path="/home/shift-choose"
            element={<ShiftChoosePage />}
          ></Route>
          <Route path="/home/overtimes-form" element={<Overtime2 />}></Route>
          <Route path="/home/overtimes-list" element={<OvertimeList />}></Route>
          <Route
            path="/home/patrol-location"
            element={<PatrolLocation />}
          ></Route>
          <Route
            path="/home/patrol-qrcode"
            // /:id"
            element={<PatrolQrcode />}
          ></Route>
          <Route path="/home/patrol/:id" element={<PatrolPage />}></Route>
          <Route
            path="/home/shift/map-location/:lat/:lon/:shiftId/:action"
            element={<MapComponent />}
          ></Route>
          <Route path="/home/log-book-list" element={<LogBookList />}></Route>
          <Route
            path="/home/log-book-list/vehicle/:id"
            element={<LogVehicle />}
          ></Route>
          <Route
            path="/home/log-book-list/product/:id"
            element={<LogProduct />}
          ></Route>
          <Route path="/home/payroll" element={<Payroll />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
